import { NgModule } from '@angular/core';
import { RouterModule, PreloadAllModules } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { CriteriaAddComponent } from './criteria/criteria.add.component';
import { VisionCriteriasComponent } from './vision/vision.criterias.component';
import { AuthService } from './services/auth/auth.service';
import { AuthGuard } from './services/auth/auth.guard';
import { LoginRedirectGuard } from './services/auth/login-redirect.guard';
import { HomeUserComponent } from './home/home.user.component';
import { JobsEmptyComponent } from './jobs/jobs-empty.component';
import { JobsVisionsComponent } from './jobs/jobs-visions.component';
import { JobsAddedComponent } from './jobs/jobs-added.component';
import { JobsCreateComponent } from './jobs/jobs-create.component';
import { JobsEditComponent } from './jobs/jobs-edit.component';
import { VisionCriteriasEditComponent } from './vision/vision.criterias-edit.component';
import { CriteriaEditComponent } from './criteria/criteria.edit.component';


@NgModule({
    imports: [
        RouterModule.forRoot([
            { path: 'login', component: AuthGuard },
            { path: 'vision/addcriteria', component: CriteriaAddComponent, canActivate: [AuthGuard, LoginRedirectGuard] },
            { path: 'vision/addcriteria/:importance', component: CriteriaAddComponent, canActivate: [AuthGuard, LoginRedirectGuard] },
            { path: 'vision/addcriteria/:visiontype', component: CriteriaAddComponent, canActivate: [AuthGuard, LoginRedirectGuard] },
            { path: 'vision/criterias', component: VisionCriteriasComponent, canActivate: [AuthGuard, LoginRedirectGuard] },
            { path: 'vision/editcriterias', component: VisionCriteriasEditComponent, canActivate: [AuthGuard, LoginRedirectGuard] },
            {
                path: 'vision/editcriterias:visiontype', component: VisionCriteriasEditComponent,
                canActivate: [AuthGuard, LoginRedirectGuard]
            },
            { path: 'criteria/edit', component: CriteriaEditComponent, canActivate: [AuthGuard, LoginRedirectGuard] },
            { path: 'criteria/edit/:id', component: CriteriaEditComponent, canActivate: [AuthGuard, LoginRedirectGuard] },
            { path: 'home/user', component: HomeUserComponent, canActivate: [AuthGuard, LoginRedirectGuard] },
            { path: 'jobs', component: JobsEmptyComponent, canActivate: [AuthGuard, LoginRedirectGuard] },
            { path: 'vision/jobs', component: JobsAddedComponent, canActivate: [AuthGuard, LoginRedirectGuard] },
            { path: 'vision/jobs/:visiontype', component: JobsAddedComponent, canActivate: [AuthGuard, LoginRedirectGuard] },
            { path: 'jobs/visions', component: JobsVisionsComponent, canActivate: [AuthGuard, LoginRedirectGuard] },
            { path: 'vision/addjob', component: JobsCreateComponent, canActivate: [AuthGuard, LoginRedirectGuard] },
            { path: 'job/edit', component: JobsEditComponent, canActivate: [AuthGuard, LoginRedirectGuard] },
            { path: 'job/edit/:id', component: JobsEditComponent, canActivate: [AuthGuard, LoginRedirectGuard] },
            { path: 'vision/addjob/:visiontype', component: JobsCreateComponent, canActivate: [AuthGuard, LoginRedirectGuard] },
            { path: 'home', component: HomeComponent },
            { path: '', component: HomeComponent }
        ])
    ],
    exports: [RouterModule]
})

export class Routes { }



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/routes.ts